module.exports = __webpack_public_path__ + "img/pic4.c6b564be.jpg";